module.exports = __webpack_public_path__ + "img/IMG_0459_L_WoodMatted_MockedUp.6d0d3e11.jpg";